import { Image } from 'src/app/people/models/image';
export class PointOfContact {
  public id: string;
  public email: string;
  public name: string;
  public imageId: string;
  public image: Image;
  constructor(id: string, email: string, name: string, imageId: string) {
    this.id = id;
    this.email = email;
    this.name = name;
    this.imageId = imageId;
    this.image = imageId ? new Image(imageId) : null;
  }
  static parse(data: any): PointOfContact {
    if (!data) {
      return null;
    }
    return new PointOfContact(data.id, data.email, data.name, data.imageId);
  }
}
